import React from "react"
import { Auth } from "./auth/index"
import { history } from "./history"
import { Router, Route, Switch, Redirect } from "react-router-dom"
import Help from "../src/Pages/Help"
import Welcome from "../src/Pages/WelcomePage"
import Error from "../src/Pages/Error"
import NewLoginPage from "./Pages/Login/NewLoginPage"
import ApplicationsListWrapper from "./Pages/Dashboard/ApplicationsListWrapper"
import DashboardWrapper from "./Pages/Dashboard/DashboardWrapper"
import ExternalDashboardWrapper from "./Pages/Dashboard/ExternalDashboardWrapper"
import ChatBotWrapper from "./Pages/Dashboard/ChatBotWrapper"
import LoginPageNew from "./Pages/Login/LoginPageNew"


const PrivateRoute = ({ component: Component, requiresAdminRole, requiresUserRole, requiresWriteRole, ...rest }) => {
  let isAuth = Auth.isUserAuthenticated();
  // let hasAppropriateRole = false;
  let hasAppropriateRole


  // if (isAuth) {
  let userRoles = localStorage.getItem("roles");
  // let userRoles = JSON.parse(input)
  // let hasAdminRole = (userRoles?.search("NAT_ADMIN_ROLE") !== -1) ? true : false;
  // let hasUserRole = (userRoles?.search("NAT_USER_ROLE") !== -1) ? true : false;
  // let hasWriteRole = (userRoles?.search("NAT_WRITE_ROLE") !== -1) ? true : false;

  let hasAdminRole = userRoles?.includes("NAT_ADMIN_ROLE")
  let hasUserRole = userRoles?.includes("NAT_USER_ROLE")
  let hasWriteRole = userRoles?.includes("NAT_WRITE_ROLE")

  // Admin Role Requirement To See The Page
  if (hasAdminRole)
    hasAppropriateRole = true;
  // User And Write Role Requirement To See The Page
  else if ((requiresUserRole && requiresWriteRole) && (hasUserRole && hasWriteRole))
    hasAppropriateRole = true;
  // No Role Requirement To See The Page
  else if (!requiresAdminRole && !requiresUserRole && !requiresWriteRole)
    hasAppropriateRole = true;
  // }

  return (
    <Route
      {...rest}
      render={props =>
        isAuth
          ? hasAppropriateRole
            ? <Component {...props} />
            : <Redirect to="/error" />
          :
          <Redirect
            to={{
              pathname: "/neoAutomataSuites/login",
              state: { from: props.location }
            }}
          />
      }
    />
  );
};

const Routes = () => (
  <Router history={history} basename={"/neoAutomataSuites"}>
    <Switch>

      {/* test */}
      {/* <Route exact path={`${process.env.PUBLIC_URL}/login`} component={NewLoginPage} /> */}
      {/* test */}
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/`}
        component={
          LoginPageNew
        }
      />
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/login`}
        component={
          LoginPageNew
        }
      />

      <PrivateRoute exact path={`${process.env.PUBLIC_URL}/externalDashboard`} component={ExternalDashboardWrapper} requiresAdminRole={false} requiresUserRole={false} requiresWriteRole={false} />
      <PrivateRoute exact path={`${process.env.PUBLIC_URL}/applicationsList`} component={ApplicationsListWrapper} requiresAdminRole={false} requiresUserRole={false} requiresWriteRole={false} />
      <PrivateRoute exact path={`${process.env.PUBLIC_URL}/myDashboard`} component={DashboardWrapper} requiresAdminRole={false} requiresUserRole={false} requiresWriteRole={false} />
      <PrivateRoute exact path={`${process.env.PUBLIC_URL}/aichatbot`} component={ChatBotWrapper} requiresAdminRole={false} requiresUserRole={false} requiresWriteRole={false} />

      <PrivateRoute path={`${process.env.PUBLIC_URL}/help`} component={Help} requiresAdminRole={false} requiresUserRole={false} requiresWriteRole={false} />
      <PrivateRoute path={`${process.env.PUBLIC_URL}/welcome`} component={Welcome} requiresAdminRole={false} requiresUserRole={false} requiresWriteRole={false} />
      <PrivateRoute path="*" component={Error} requiresAdminRole={false} requiresUserRole={false} requiresWriteRole={false} />
    </Switch>
  </Router>
);

export default Routes;